const e = class e extends HTMLElement {
  memoizedTemplate() {
    const t = this.is();
    if (e.TEMPLATE_CACHE[t])
      return e.TEMPLATE_CACHE[t];
    const i = this.template();
    return window.ShadyCSS && window.ShadyCSS.prepareTemplate(i, this.is()), e.TEMPLATE_CACHE[t] = i, i;
  }
  connectedCallback() {
    const t = this.memoizedTemplate();
    window.ShadyCSS && window.ShadyCSS.styleElement(this), this.shadowRoot || (this.attachShadow({ mode: "open" }), this.shadowRoot.appendChild(document.importNode(t.content, !0)), requestAnimationFrame(() => this.dispatchEvent(new CustomEvent("ready"))));
  }
  whenReady(t) {
    this.shadowRoot ? t() : this.addEventListener("ready", () => t());
  }
};
e.TEMPLATE_CACHE = {};
let s = e;
export {
  s as ElementBase
};
//# sourceMappingURL=element-base.mjs.map
